module.exports = __webpack_public_path__ + "static/media/panaderia_checked.3b28215f.svg";